import React from 'react';
import type { RadioOverrides, RadioGroupOverrides } from 'baseui/radio';
import type { EnhancedQuestion, Answer } from '../../types';
import { getErrorMessageFromQuestion } from '../../utils';
import { ALIGN, RadioGroup, Radio } from 'baseui/radio';
export type RadioInputProps = {
  question: EnhancedQuestion;
  answer?: Answer;
  radioGroupOverrides?: RadioGroupOverrides;
  radioOverrides?: RadioOverrides;
  setAnswerForQuestion: (questionId: string, answers: string[]) => void;
};
const RadioInput = ({
  question,
  answer,
  radioGroupOverrides,
  radioOverrides,
  setAnswerForQuestion
}: RadioInputProps) => {
  const value = answer?.answers[0];
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAnswerForQuestion(question.id, [e.currentTarget.value]);
  };
  return <RadioGroup value={value} onChange={onChange} name={question.id} align={ALIGN.vertical} overrides={radioGroupOverrides} error={!!getErrorMessageFromQuestion(question)}>
      {question.answerOptions.map(option => <Radio value={option.answer} key={option.answer} overrides={radioOverrides}>
          {option.answer}
        </Radio>)}
    </RadioGroup>;
};
export default RadioInput;